import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { SortOrder } from '@common/utils/search-sort';

export enum AvailableTabsOnNotificationsPage {
  Settings = 'settings',
  Triggered = 'triggered',
}

export enum AvailableNotificationsFilterValue {
  Active = 'active',
  Inactive = 'inactive',
  All = 'all',
}

export interface NotificationsSettingsTabPageState {
  searchValue: string;
  filterValue: AvailableNotificationsFilterValue;
  sortOrder: SortOrder;
}

export interface NotificationsTriggeredTabPageState {
  searchValue: string;
}

export interface LastNotificationsPageStateWithTabs {
  activeTabOnPage: AvailableTabsOnNotificationsPage;
  [AvailableTabsOnNotificationsPage.Settings]: NotificationsSettingsTabPageState;
  [AvailableTabsOnNotificationsPage.Triggered]: NotificationsTriggeredTabPageState;
}

export interface NotificationItem {
  id: number;
  name: string;
  isActive: boolean;
  [key: string]: any;
}

export const notificationsAdapter = createEntityAdapter<NotificationItem>({
  selectId: (item) => item.id,
});

export interface NotificationsState extends EntityState<NotificationItem> {
  lastPageState: LastNotificationsPageStateWithTabs;
  loading: boolean;
  error?: string;
}

export const initialStateNotifications: NotificationsState = notificationsAdapter.getInitialState({
  lastPageState: {
    activeTabOnPage: AvailableTabsOnNotificationsPage.Settings,
    [AvailableTabsOnNotificationsPage.Settings]: {
      searchValue: '',
      filterValue: AvailableNotificationsFilterValue.All,
      sortOrder: SortOrder.Asc,
    },
    [AvailableTabsOnNotificationsPage.Triggered]: {
      searchValue: '',
    },
  },
  loading: false,
  error: undefined,
});
